'use strict';


module.exports = function (client) {

    client.disco.addFeature('jabber:iq:version');

    client.on('iq:get:version', function (iq) {
        client.sendIq(iq.resultReply({
            version: client.config.softwareVersion || {
                name: 'stanza.io'
            }
        }));
    });

    client.getSoftwareVersion = function (jid, cb) {
        return this.sendIq({
            to: jid,
            type: 'get',
            version: true
        }, cb);
    };
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/version.js
// module id = 636
// module chunks = 2